import React from "react";
import CrudModule, { StatusBadge } from "@/components/CrudModule";
import { fmtDate } from "@/lib/api";

export default function Fleet() {
  return (
    <CrudModule
      title="Fleet"
      subtitle="Trucks, pickups, tankers & forklifts — insurance, service & maintenance."
      endpoint="fleet"
      testid="fleet"
      headerImage="https://images.pexels.com/photos/18468423/pexels-photo-18468423.jpeg?auto=compress&w=1200"
      columns={[
        { key: "name", label: "Vehicle" },
        { key: "type", label: "Type" },
        { key: "plate", label: "Plate", mono: true },
        { key: "driver", label: "Driver" },
        { key: "status", label: "Status", render: (v) => <StatusBadge value={v} /> },
        { key: "mileage", label: "Mileage", align: "right", render: (v) => Number(v).toLocaleString() },
        { key: "next_service", label: "Next Service", render: (v) => fmtDate(v) },
      ]}
      fields={[
        { key: "name", label: "Vehicle Name" },
        { key: "type", label: "Type", type: "select", options: ["Truck", "Pickup", "Tanker", "Forklift"] },
        { key: "plate", label: "License Plate" },
        { key: "driver", label: "Assigned Driver" },
        { key: "status", label: "Status", type: "select", options: ["active", "maintenance", "inactive"] },
        { key: "mileage", label: "Mileage", type: "number" },
        { key: "fuel_type", label: "Fuel Type", type: "select", options: ["Diesel", "Gasoline", "LPG"] },
        { key: "insurance_expiry", label: "Insurance Expiry", type: "date" },
        { key: "registration_expiry", label: "Registration Expiry", type: "date" },
        { key: "last_service", label: "Last Service", type: "date" },
        { key: "next_service", label: "Next Service", type: "date" },
      ]}
    />
  );
}
